import { ethers } from "ethers";
import { getContract } from "./contracts";
import { ARBITRUM, AVALANCHE, HAVEN1_TESTNET, HAVEN1_MAINNET, getExplorerUrl, SUPPORTED_CHAIN_IDS } from "./chains";
import { Token } from "domain/tokens";
import { NATIVE_TOKEN_DECIMALS } from "config/factors";

export const TOKENS: { [chainId: number]: Token[] } = {
  [HAVEN1_TESTNET]: [
    {
      name: "H1",
      symbol: "H1",
      decimals: NATIVE_TOKEN_DECIMALS,
      address: ethers.constants.AddressZero,
      isNative: true,
      isShortable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/28771/large/haven1-colored-symbol_2x_%281%29.png?1696527751",
    },
    {
      name: "wH1",
      symbol: "wH1",
      decimals: 18,
      address: "0x3A4376273545B3f4261Bf42f221567A393C9871D",
      isShortable: true,
      isWrapped: true,
      baseSymbol: "H1",
      imageUrl: "https://assets.coingecko.com/coins/images/28771/large/haven1-colored-symbol_2x_%281%29.png?1696527751",
    },
    {
      name: "hETH",
      symbol: "hETH",
      decimals: 18,
      address: "0xc78d99244Cf9885187BcE49a651D6aB5caD0C042",
      isShortable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880",
    },
    {
      name: "hBTC",
      symbol: "hBTC",
      decimals: 8,
      address: "0x21d44FeDE125C24a95699470Dd7EF8ab246016C4",
      isShortable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    },
    {
      name: "hUSDC",
      symbol: "hUSDC",
      address: "0x61Dc72dde37915C918AFE1032CF69E1C1EEC0D60",
      decimals: 6,
      isStable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389",
    },
    {
      name: "hUSDT",
      symbol: "hUSDT",
      decimals: 6,
      address: "0xf4e5d5f36d58Df84a916F816D65314476c98E81d",
      isStable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png?1598003707",
    },
  ],
  [HAVEN1_MAINNET]: [
    {
      name: "H1",
      symbol: "H1",
      decimals: 18,
      address: ethers.constants.AddressZero,
      isNative: true,
      isShortable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/28771/large/haven1-colored-symbol_2x_%281%29.png?1696527751",
    },
    {
      name: "wH1",
      symbol: "wH1",
      decimals: 18,
      address: "",
      isShortable: true,
      isWrapped: true,
      imageUrl: "https://assets.coingecko.com/coins/images/28771/large/haven1-colored-symbol_2x_%281%29.png?1696527751",
    },
    {
      name: "hETH",
      symbol: "hETH",
      decimals: 18,
      address: "",
      isShortable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880",
    },
    {
      name: "hBTC",
      symbol: "hBTC",
      decimals: 6,
      address: "",
      isShortable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
    },
    {
      name: "hUSDC",
      symbol: "hUSDC",
      decimals: 6,
      address: "",
      isStable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/6319/thumb/USD_Coin_icon.png?1547042389",
    },
    {
      name: "hUSDT",
      symbol: "hUSDT",
      decimals: 18,
      address: "",
      isStable: true,
      imageUrl: "https://assets.coingecko.com/coins/images/325/thumb/Tether-logo.png?1598003707",
    },
  ],
};

export const ADDITIONAL_TOKENS: { [chainId: number]: Token[] } = {
  [HAVEN1_TESTNET]: [
    {
      name: "Escrowed H1",
      symbol: "esH1",
      address: getContract(HAVEN1_TESTNET, "ES_GMX"),
      decimals: 18,
    },
    {
      name: "Haven LP",
      symbol: "HLP",
      address: getContract(HAVEN1_TESTNET, "GLP"),
      decimals: 18,
      imageUrl: "https://github.com/gmx-io/gmx-assets/blob/main/GMX-Assets/PNG/GLP_LOGO%20ONLY.png?raw=true",
    },
  ],
  [HAVEN1_MAINNET]: [
    {
      name: "Escrowed H1",
      symbol: "esH1",
      address: getContract(HAVEN1_MAINNET, "ES_GMX"),
      decimals: 18,
    },
    {
      name: "Haven LP",
      symbol: "HLP",
      address: getContract(HAVEN1_MAINNET, "GLP"),
      decimals: 18,
      imageUrl: "https://github.com/gmx-io/gmx-assets/blob/main/GMX-Assets/PNG/GLP_LOGO%20ONLY.png?raw=true",
    },
  ],
};

export const PLATFORM_TOKENS: { [chainId: number]: { [symbol: string]: Token } } = {
  [ARBITRUM]: {
    // arbitrum
    GMX: {
      name: "GMX",
      symbol: "GMX",
      decimals: 18,
      address: getContract(ARBITRUM, "GMX"),
      imageUrl: "https://assets.coingecko.com/coins/images/18323/small/arbit.png?1631532468",
    },
    GLP: {
      name: "GMX LP",
      symbol: "GLP",
      decimals: 18,
      address: getContract(ARBITRUM, "StakedGlpTracker"), // address of fsGLP token because user only holds fsGLP
      imageUrl: "https://github.com/gmx-io/gmx-assets/blob/main/GMX-Assets/PNG/GLP_LOGO%20ONLY.png?raw=true",
    },
  },
  [AVALANCHE]: {
    // avalanche
    GMX: {
      name: "GMX",
      symbol: "GMX",
      decimals: 18,
      address: getContract(AVALANCHE, "GMX"),
      imageUrl: "https://assets.coingecko.com/coins/images/18323/small/arbit.png?1631532468",
    },
    GLP: {
      name: "GMX LP",
      symbol: "GLP",
      decimals: 18,
      address: getContract(AVALANCHE, "StakedGlpTracker"), // address of fsGLP token because user only holds fsGLP
      imageUrl: "https://github.com/gmx-io/gmx-assets/blob/main/GMX-Assets/PNG/GLP_LOGO%20ONLY.png?raw=true",
    },
  },
  [HAVEN1_TESTNET]: {
    HLP: {
      name: "Haven LP",
      symbol: "HLP",
      decimals: 18,
      address: getContract(HAVEN1_TESTNET, "StakedGlpTracker"), // address of fsGLP token because user only holds fsGLP
      imageUrl: "https://github.com/gmx-io/gmx-assets/blob/main/GMX-Assets/PNG/GLP_LOGO%20ONLY.png?raw=true",
    },
  },
  [HAVEN1_MAINNET]: {
    HLP: {
      name: "Haven LP",
      symbol: "HLP",
      decimals: 18,
      address: getContract(HAVEN1_MAINNET, "StakedGlpTracker"), // address of fsGLP token because user only holds fsGLP
      imageUrl: "https://github.com/gmx-io/gmx-assets/blob/main/GMX-Assets/PNG/GLP_LOGO%20ONLY.png?raw=true",
    },
  },
};

export const ICONLINKS = {
  [HAVEN1_TESTNET]: {
    H1: {
      base: `${getExplorerUrl(HAVEN1_TESTNET, "address")}/0x3A4376273545B3f4261Bf42f221567A393C9871D`,
    },
    wH1: {
      base: `${getExplorerUrl(HAVEN1_TESTNET, "address")}/0x3A4376273545B3f4261Bf42f221567A393C9871D`,
    },
    HLP: {
      base: `${getExplorerUrl(HAVEN1_TESTNET, "address")}/0xb61b22A8AB6815df03c4975d9496bF4Bc223619F`,
    },
    hETH: {
      coingecko: "",
      base: `${getExplorerUrl(HAVEN1_TESTNET, "address")}/0xc78d99244Cf9885187BcE49a651D6aB5caD0C042`,
    },
    hBTC: {
      coingecko: "",
      base: `${getExplorerUrl(HAVEN1_TESTNET, "address")}/0x21d44FeDE125C24a95699470Dd7EF8ab246016C4`,
    },
    hUSDC: {
      coingecko: "",
      base: `${getExplorerUrl(HAVEN1_TESTNET, "address")}/0x61Dc72dde37915C918AFE1032CF69E1C1EEC0D60`,
    },
    hUSDT: {
      coingecko: "",
      base: `${getExplorerUrl(HAVEN1_TESTNET, "address")}/0xf4e5d5f36d58Df84a916F816D65314476c98E81d`,
    },
  },
  [HAVEN1_MAINNET]: {
    H1: {
      base: `${getExplorerUrl(HAVEN1_TESTNET, "address")}/0x3A4376273545B3f4261Bf42f221567A393C9871D`,
    },
    HLP: {
      base: `${getExplorerUrl(HAVEN1_MAINNET, "address")}`,
    },
    hETH: {
      coingecko: "",
      base: `${getExplorerUrl(HAVEN1_MAINNET, "address")}`,
    },
    hBTC: {
      coingecko: "",
      base: `${getExplorerUrl(HAVEN1_MAINNET, "address")}`,
    },
    hUSDC: {
      coingecko: "",
      base: `${getExplorerUrl(HAVEN1_MAINNET, "address")}`,
    },
    hUSDT: {
      coingecko: "",
      base: `${getExplorerUrl(HAVEN1_MAINNET, "address")}`,
    },
  },
};

export const HLP_POOL_COLORS = {
  ETH: "#6062a6",
  BTC: "#F7931A",
  WBTC: "#F7931A",
  USDC: "#2775CA",
  "USDC.e": "#2A5ADA",
  anotherUSDT: "#67B18A",
  anotherWBTC: "#F7931A",
  USDT: "#67B18A",
  MIM: "#9695F8",
  FRAX: "#000",
  DAI: "#FAC044",
  UNI: "#E9167C",
  AVAX: "#E84142",
  LINK: "#3256D6",
  // haven
  wH1: "#2A5ADA",
  H1: "#2A5ADA",
  hBTC: "#F7931A",
  hUSDT: "#67B18A",
  hUSDC: "#2775CA",
  hETH: "#6062a6",
};

export const TOKENS_MAP: { [chainId: number]: { [address: string]: Token } } = {};
export const TOKENS_BY_SYMBOL_MAP: { [chainId: number]: { [symbol: string]: Token } } = {};
export const WRAPPED_TOKENS_MAP: { [chainId: number]: Token } = {};
export const NATIVE_TOKENS_MAP: { [chainId: number]: Token } = {};

// const SUPPORTED_CHAIN_IDS = [MAINNET, TESTNET, ARBITRUM, ARBITRUM_TESTNET, AVALANCHE, AVALANCHE_FUJI, HAVEN1_TESTNET];
// TODO: remove comment, Note: currently trying to get rid of unnecessary chains

for (let j = 0; j < SUPPORTED_CHAIN_IDS.length; j++) {
  const chainId = SUPPORTED_CHAIN_IDS[j];
  TOKENS_MAP[chainId] = {};
  TOKENS_BY_SYMBOL_MAP[chainId] = {};
  let tokens = TOKENS[chainId];
  if (ADDITIONAL_TOKENS[chainId]) {
    tokens = tokens.concat(ADDITIONAL_TOKENS[chainId]);
  }

  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    TOKENS_MAP[chainId][token.address] = token;
    TOKENS_BY_SYMBOL_MAP[chainId][token.symbol] = token;
  }
}

for (const chainId of SUPPORTED_CHAIN_IDS) {
  for (const token of TOKENS[chainId]) {
    if (token.isWrapped) {
      WRAPPED_TOKENS_MAP[chainId] = token;
    } else if (token.isNative) {
      NATIVE_TOKENS_MAP[chainId] = token;
    }
  }
}

export function getWrappedToken(chainId: number) {
  return WRAPPED_TOKENS_MAP[chainId];
}

export function getNativeToken(chainId: number) {
  return NATIVE_TOKENS_MAP[chainId];
}

export function getTokens(chainId: number) {
  return TOKENS[chainId];
}

export function isValidToken(chainId: number, address: string) {
  if (!TOKENS_MAP[chainId]) {
    throw new Error(`Incorrect chainId ${chainId}`);
  }
  return address in TOKENS_MAP[chainId];
}

export function getToken(chainId: number, address: string) {
  if (!TOKENS_MAP[chainId]) {
    throw new Error(`Incorrect chainId ${chainId}`);
  }
  if (!TOKENS_MAP[chainId][address]) {
    console.error(`Incorrect address "${address}" for chainId ${chainId}`);
    return null;
  }
  return TOKENS_MAP[chainId][address];
}

export function getTokenBySymbol(chainId: number, symbol: string) {
  const token = TOKENS_BY_SYMBOL_MAP[chainId][symbol];
  if (!token) {
    throw new Error(`Incorrect symbol "${symbol}" for chainId ${chainId}`);
  }
  return token;
}

export function getWhitelistedTokens(chainId: number) {
  return TOKENS[chainId].filter((token) => token.symbol.toUpperCase() !== "USDG");
}

export function getVisibleTokens(chainId: number) {
  return getWhitelistedTokens(chainId).filter((token) => !token.isWrapped && !token.isTempHidden);
}

export function getNormalizedTokenSymbol(tokenSymbol) {
  if (["WBTC", "WETH", "WAVAX"].includes(tokenSymbol)) {
    return tokenSymbol.substr(1);
  } else if (tokenSymbol === "BTC.b") {
    return "BTC";
  }
  return tokenSymbol;
}

const AVAILABLE_CHART_TOKENS = {
  [ARBITRUM]: ["ETH", "BTC", "LINK", "UNI"],
  [AVALANCHE]: ["AVAX", "ETH", "BTC"],
  [HAVEN1_TESTNET]: ["hBTC", "hETH", "H1"],
  [HAVEN1_MAINNET]: ["hBTC", "hETH", "H1"],
};

export function isChartAvailabeForToken(chainId: number, tokenSymbol: string) {
  const token = getTokenBySymbol(chainId, tokenSymbol);
  if (!token) return false;
  return (token.isStable || AVAILABLE_CHART_TOKENS[chainId]?.includes(getNormalizedTokenSymbol(tokenSymbol))) ?? false;
}

export function getPriceDecimals(chainId: number, tokenSymbol?: string) {
  if (!tokenSymbol) return 2;

  try {
    const token = getTokenBySymbol(chainId, tokenSymbol);
    return token.priceDecimals ?? 2;
  } catch (e) {
    return 2;
  }
}
